import config from "environment";
import { getRequest, postRequest } from "./client";

const { baseApi } = config;

export async function apiSlackMessageTemplateDownload(
    payload: { templateId: string; email: string }
): Promise<boolean> {
  const fetchURL = `${baseApi}/slack/template-download`;
  console.log("[apiSlackMessageTemplateDownload] payload: ", payload);
  return await postRequest(fetchURL, payload, "API/apiSlackMessageTemplateDownload");
}
